module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/11 a Klizka s kosti + nakrajene platky osso bucco.jpg";